import React from 'react'
import PropTypes from 'prop-types'

class CloudwaysLoader extends React.Component {
	render() {
		const { message } = this.props
		return <div className="cws">
			<div className="cws-loader text-center tall">
				<img src="/assets/cloudways/cloudways-logo.png" alt=""/>
				<h1 className="loader-message color-3758bf">{message || "Loading"}
					<span className="loading-dot">.</span>
					<span className="loading-dot">.</span>
					<span className="loading-dot">.</span>
				</h1>
			</div>
		</div>
	}
}

CloudwaysLoader.propTypes = {
	message: PropTypes.string
}

export default CloudwaysLoader
